import { PaymentFrequency } from '../../models/config/payment-frequency.enum';
import { PlanDetails } from '../../models/plan-details/plan-details.interface';
import { mockAchDiscountData } from './ach-discount-data.mock';

export const mockPlanDetails: PlanDetails = {
  status: 'success',
  contractNumber: 'DG0000590644',
  lineItemId: 'N/A',
  achDiscountData: mockAchDiscountData,
  effectiveDate: '2024-12-10',
  expirationDate: '2025-12-10',
  paymentFrequency: PaymentFrequency.Monthly,
  planNumber: 'DG0000590072',
  price: 4.34,
  tax: 0.35,
  warrantyProductName: 'Appliance Care Monthly IW/OOW',
};
